import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./features/userSlice";
import { AuthApi } from "./api/user/AuthApi";
import { PricingApi } from "./api/pricing/PricingApi";
import { AdminApi } from "./api/Admin/AdminApi";
import { RidesApi } from "./api/Ride/RidesApi";
import { ComplaintApi } from "./api/Complaints/ComplainApi";
import { DashboardApi } from "./api/Dashboard/DashboardApi";
import { LongDriveApi } from "./api/LongDrive/LongDriveApi";
import { WalletApi } from "./api/Wallet/WalletApi";
import { VehicleApi } from "./api/Vehicle/VehicleApi";
import { NotificationApi } from "./api/Notifications/NotificationApi";
import { MarqueeApi } from "./api/Marquee/MarqueeApi";
import { ExportApi } from "./api/Export/ExportApi";
import { PromotionApi } from "./api/Promotion/PromotionApi";
import { BannerApi } from "./api/Banner/BannerApi";

export const store = configureStore({
  reducer: {
    User: UserReducer, // UserReducer slice
    [AuthApi.reducerPath]: AuthApi.reducer, // AuthApi slice
    [PricingApi.reducerPath]: PricingApi.reducer,
    [AdminApi.reducerPath]: AdminApi.reducer,
    [RidesApi.reducerPath]: RidesApi.reducer,
    [ComplaintApi.reducerPath]: ComplaintApi.reducer,
    [DashboardApi.reducerPath]: DashboardApi.reducer,
    [LongDriveApi.reducerPath]: LongDriveApi.reducer,
    [WalletApi.reducerPath]: WalletApi.reducer,
    [VehicleApi.reducerPath]: VehicleApi.reducer,
    [NotificationApi.reducerPath]: NotificationApi.reducer,
    [MarqueeApi.reducerPath]: MarqueeApi.reducer,
    [ExportApi.reducerPath]: ExportApi.reducer,
    [PromotionApi.reducerPath]: PromotionApi.reducer,
    [BannerApi.reducerPath]: BannerApi.reducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      AuthApi.middleware,
      PricingApi.middleware,
      AdminApi.middleware,
      RidesApi.middleware,
      ComplaintApi.middleware,
      DashboardApi.middleware,
      LongDriveApi.middleware,
      WalletApi.middleware,
      VehicleApi.middleware,
      NotificationApi.middleware,
      MarqueeApi.middleware,
      ExportApi.middleware,
      PromotionApi.middleware,
      BannerApi.middleware,
    ]),
});
